import styles from './OneGameBlock.module.scss';
import GameThumbnailManager from 'Components/shared/GameThumbnailManager/GameThumbnailManager';
import { IApplicationState, IGame, listGames } from '@spinwise/spinwise-core';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  BaseText,
  EBaseTextPosition,
  EBaseTextSize,
  EBaseTextWeight,
} from '@spinwise/react-component-library/BaseText';
import { EBrandTextColor } from 'Libraries/typography.library';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';

const OneGameBlock = ({ title, description, category_id }) => {
  const gamesByCategory = useSelector((state: IApplicationState) => state.gamesReducer.gamesByCategory?.[category_id]);
  const dispatch = useDispatch();
  const { integrationKeys } = useSelector((state: IApplicationState) => state.globalReducer);

  useEffect(() => {
    const payload = {
      category: [category_id],
      gamesPerPage: null,
      limit: 0,
      showBonusAllowed: false,
    };
    listGames(payload)(dispatch);
  }, []);

  const getintegrationKey = item => {
    let integrationKey = integrationKeys.keys?.[item.urlKey];

    return integrationKey ?? false;
  };

  return (
    <div className={styles.onegameblock_container}>
      <div className={styles.onegameblock_tabletextbox}>
        <div>
          <BaseText
            value={title}
            size={EBaseTextSize.Title4}
            color={EBrandTextColor.Black09}
            weight={EBaseTextWeight.W600}
            alignment={EBaseTextPosition.Left}
          />
        </div>

        <div>
          <BaseText
            value={description}
            size={EBaseTextSize.Small}
            color={EBrandTextColor.Black04}
            weight={EBaseTextWeight.W500}
            alignment={EBaseTextPosition.Left}
          />
        </div>
      </div>
      <div className={styles.onegameblock_tablegap}></div>
      <div>
        {gamesByCategory && gamesByCategory?.length !== 0 && (
          <>
            {gamesByCategory.length == 1 && (
              <div className={styles.onegameblock_tableimgbox}>
                <div className={`${EComponentVisibility.DesktopOnly}`}>
                  {gamesByCategory.map((item: IGame, i: number) => {
                    let integrationKey = getintegrationKey(item);
                    return (
                      <GameThumbnailManager
                        key={item?.eid}
                        game={item}
                        integrationKeys={integrationKey}
                        size={200}
                      ></GameThumbnailManager>
                    );
                  })}
                </div>

                <div className={`${EComponentVisibility.MobileTablet}`}>
                  {gamesByCategory.map((item: IGame, i: number) => {
                    let integrationKey = getintegrationKey(item);
                    return (
                      <GameThumbnailManager
                        key={item?.eid}
                        game={item}
                        integrationKeys={integrationKey}
                        size={146}
                      ></GameThumbnailManager>
                    );
                  })}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OneGameBlock;
